var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTilesView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3H12V12H21V3ZM22.5 12V13.5V22.5C22.5 23.3284 21.8284 24 21 24H12H10.5H1.5C0.671573 24 0 23.3284 0 22.5V13.5V12V3C0 2.17157 0.671573 1.5 1.5 1.5H10.5H12H21C21.8284 1.5 22.5 2.17157 22.5 3V12ZM1.5 13.5V22.5H10.5V13.5H1.5ZM10.5 12H1.5V3H10.5V12ZM12 13.5V22.5H21V13.5H12Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTilesView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tiles-view.e73f48a1d297b0de33d33e7eb2f0bb70.svg";